import {
  Banknote,
  Briefcase,
  Car,
  CircleDollarSign,
  CreditCard,
  Film,
  GraduationCap,
  HeartPulse,
  Home,
  Laptop,
  MoreHorizontal,
  Phone,
  PlusCircle,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Store,
  Tag,
  TrendingUp,
  Users,
  Utensils,
  Zap,
  type LucideIcon,
} from "lucide-react";

/** Category icons are stored as slugs; unknown slugs fall back to a tag. */
export const CATEGORY_ICONS: Record<string, LucideIcon> = {
  briefcase: Briefcase,
  store: Store,
  laptop: Laptop,
  "trending-up": TrendingUp,
  "plus-circle": PlusCircle,
  utensils: Utensils,
  home: Home,
  car: Car,
  zap: Zap,
  "graduation-cap": GraduationCap,
  "heart-pulse": HeartPulse,
  users: Users,
  film: Film,
  "shopping-bag": ShoppingBag,
  "shopping-cart": ShoppingCart,
  phone: Phone,
  shield: Shield,
  "credit-card": CreditCard,
  "more-horizontal": MoreHorizontal,
  banknote: Banknote,
  dollar: CircleDollarSign,
  tag: Tag,
};

export function CategoryIcon({ slug, className = "size-4" }: { slug: string | null | undefined; className?: string }) {
  const Icon = (slug && CATEGORY_ICONS[slug]) || Tag;
  return <Icon className={className} aria-hidden />;
}
